import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Flex,
  VStack,
  Link,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Eye, EyeSlash } from "phosphor-react";
import logo from "../../Assets/logo.png";
import logo1 from "../../Assets/logo1.png";
import bg from "../../Assets/InitBg.png";
import { COLORS } from "../../Helper/Colors";
import DotSpinner from "../../Components/Common/DotSpinner";
import { Form } from "./Login.style";
import { useNavigate, useLocation, Link as ReachLink } from "react-router-dom";
import { YEAR } from "../../Helper/Constants";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { login } from "../../Redux/Auth/Actions";
import Api from "../../Helper/ApiHandler";
import { FormInput } from "../../Components/Common/UI";

const Login = () => {
  const api = new Api();
  let toast = useToast();
  let navigate = useNavigate();
  let location = useLocation();
  const dispatch = useDispatch();
  let to = location.state?.from || "/";
  const [serverError, setServerError] = useState(
    location.state?.loggedOut || null
  );
  const [showPassword, setShowPassword] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [cookies, setCookie] = useCookies(["jomtoken"]);

  useEffect(() => {
    if (cookies.jomtoken) {
      navigate(to, { replace: true });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to, cookies]);
  const initialValues = {
    email: "",
    password: "",
    rememberMe: true,
  };
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter valid email!")
      .required("Email is required!"),
    rememberMe: yup.boolean().required("Remember me is required!"),
    password: yup.string().required("Password is required!"),
    // .matches(
    // 	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    // 	"The password must be atleast 8 characters and contain atleast 1 uppercase character, 1 special character and 1 digit."
    // ),
  });

  const handleFormSubmit = async (values) => {
    try {
      setServerError(null);
      setBtnLoading(true);
      const data = await api.post("auth/login", {
        email: values.email,
        password: values.password,
      });
      setBtnLoading(false);

      if (data) {
        setCookie("jomtoken", data.data.token, {
          path: "/",
          sameSite: "lax",
        });
        toast({
          title: data.message,
          description: "",
          status: "success",
          duration: 1200,
          isClosable: true,
          position: "top",
        });
        dispatch(login({ ...data.data }));

        navigate("/dashboard");
      }
    } catch (error) {
      toast({
        title: error.message,
        description: "",
        status: "error",
        duration: 1200,
        isClosable: true,
        position: "top",
      });
      setBtnLoading(false);
      setServerError(error.message);
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: handleFormSubmit,
  });

  const handleChange = (name, value) => {
    formik.setFieldTouched(name, true, true);
    formik.setValues({ ...formik.values, [name]: value });
  };
  const handlePasswordShow = () => {
    setShowPassword((prev) => !prev);
  };
  const { values, touched, errors } = formik;
  return (
    <>
      <Flex
        alignItems={{ md: "center" }}
        position="relative"
        h="100vh"
        direction={{ sm: "column", md: "row" }}
      >
        <Text
          position={"absolute"}
          bottom={{ base: "10px", md: 10 }}
          left={{ sm: "0", md: "-28%" }}
          fontSize="sm"
          color={{ sm: "brand.900", md: "brand.100" }}
          width={"100%"}
          textAlign={"center"}
        >
          &copy; {YEAR}{" "}
          <Link color="brand.500" href="https://staging.just-one-moment.com/">
            justonemoment.com
          </Link>{" "}
          All Rights Reserved.
        </Text>
        <Box
          flex={{ sm: "0.15", md: "0.8" }}
          height={{ md: "100%" }}
          display={"flex"}
          alignItems={{ sm: "center", md: "center" }}
          justifyContent={"center"}
          backgroundImage={{ md: `url(${bg})` }}
          backgroundSize={"cover"}
          backgroundRepeat={"no-repeat"}
          backgroundColor={COLORS.brandDark}
        >
          <Box display={"flex"} alignItems={"center"}>
            <Box>
              <img src={logo} alt="logo" />
            </Box>
            <Box marginLeft={"20px"}>
              <img src={logo1} alt="logo" />
            </Box>
          </Box>
        </Box>
        <Box position={"relative"} flex={{ sm: "0.75", md: "1" }}>
          <Box
            display={"flex"}
            width={"100%"}
            height={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Form onSubmit={formik.handleSubmit}>
              <VStack
                spacing={{ base: 3, md: 6 }}
                marginTop={{ base: 2, md: 0 }}
                align="flex-start"
              >
                <Text fontSize={"2xl"} fontWeight={"bold"} textAlign="center">
                  Login
                </Text>
                <FormInput
                  onBlur={formik.handleBlur}
                  type="email"
                  name="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={values.email}
                  error={!!touched.email && errors.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  errorMsg={errors.email}
                  isRequired={true}
                />
                <FormInput
                  onBlur={formik.handleBlur}
                  type={!showPassword ? "password" : "text"}
                  name="password"
                  label="Password"
                  placeholder="Enter your password"
                  value={values.password}
                  error={!!touched.password && errors.password}
                  errorMsg={errors.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                  isRequired={true}
                  rightIcon={
                    !showPassword ? (
                      <Eye
                        color={COLORS.brand}
                        size={24}
                        onClick={handlePasswordShow}
                        cursor="pointer"
                      />
                    ) : (
                      <EyeSlash
                        color={COLORS.brand}
                        size={24}
                        onClick={handlePasswordShow}
                        cursor="pointer"
                      />
                    )
                  }
                />
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Link
                    as={ReachLink}
                    color="brand.500"
                    to="/forgot-password"
                    fontSize={{ sm: "14px", md: "16px" }}
                    _focus={{}}
                  >
                    Forgot password?
                  </Link>
                </Box>
                <Button
                  isLoading={btnLoading}
                  spinner={<DotSpinner key={"login"} color={"#fff"} size={8} />}
                  type="submit"
                  colorScheme="brand"
                  className="custom-btn"
                  size={"lg"}
                  isFullWidth
                >
                  LOGIN
                </Button>
              </VStack>
            </Form>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default Login;
